export type TipoEnvio = 'utilidad' | 'marketing'
export type PaisMeta = 'ecuador' | 'colombia' | 'peru' | 'mexico' | 'chile' | 'argentina' | 'otro'

export const TIPOS_ENVIO: { value: TipoEnvio; label: string }[] = [
  { value: 'utilidad', label: 'Utilidad' },
  { value: 'marketing', label: 'Marketing' },
]

export const PAISES_META: { value: PaisMeta; label: string }[] = [
  { value: 'ecuador', label: 'Ecuador' },
  { value: 'colombia', label: 'Colombia' },
  { value: 'peru', label: 'Perú' },
  { value: 'mexico', label: 'México' },
  { value: 'chile', label: 'Chile' },
  { value: 'argentina', label: 'Argentina' },
  { value: 'otro', label: 'Otro' },
]

export const MESES_META: { value: number; label: string }[] = [
  { value: 1, label: 'Enero' }, { value: 2, label: 'Febrero' },
  { value: 3, label: 'Marzo' }, { value: 4, label: 'Abril' },
  { value: 5, label: 'Mayo' }, { value: 6, label: 'Junio' },
  { value: 7, label: 'Julio' }, { value: 8, label: 'Agosto' },
  { value: 9, label: 'Septiembre' }, { value: 10, label: 'Octubre' },
  { value: 11, label: 'Noviembre' }, { value: 12, label: 'Diciembre' },
]

export interface ConsumoMeta {
  id: number
  laboratorio_id: number
  laboratorio_nombre: string
  proyecto: string
  envio: string
  descripcion: string
  total_envio: number
  valor: number
  total_valor: number
  tipo_envio: TipoEnvio
  mes: number
  pais: PaisMeta
  fecha_creacion: string
  fecha_actualizacion: string
}

export interface ConsumoMetaCreateInput {
  laboratorio_id: number
  proyecto: string
  envio: string
  descripcion?: string
  total_envio: number
  valor: number
  tipo_envio: TipoEnvio
  mes: number
  pais: PaisMeta
}

export interface ConsumoMetaUpdateInput {
  proyecto?: string
  envio?: string
  descripcion?: string
  total_envio?: number
  valor?: number
  tipo_envio?: TipoEnvio
  mes?: number
  pais?: PaisMeta
}

export interface ConsumoMetaFilters {
  laboratorio_id?: number
  tipo_envio?: TipoEnvio
  mes?: number
  anio?: number
  pais?: PaisMeta
}
